import { render, staticRenderFns } from "./gc-friendly-active.vue?vue&type=template&id=f9939698&scoped=true&"
import script from "./gc-friendly-active.vue?vue&type=script&lang=js&"
export * from "./gc-friendly-active.vue?vue&type=script&lang=js&"
import style0 from "./gc-friendly-active.vue?vue&type=style&index=0&id=f9939698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9939698",
  null
  
)

export default component.exports